const mediaItems = [
  {
    title: '本周必看 · 动作巨制精选',
    desc: '热血激战、极限追车，五部高分动作电影一次看够，高清秒播不卡顿',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20scene%20with%20warm%20golden%20lighting%2C%20dramatic%20atmosphere%2C%20film%20grain%20texture%2C%20cinematic%20color%20grading%2C%20epic%20wide%20shot%2C%20professional%20movie%20poster%20style%2C%20no%20text%20no%20people&width=800&height=450&seq=media-action-01&orientation=landscape',
    duration: '5部精选',
  },
  {
    title: '深夜剧场 · 悬疑惊悚夜',
    desc: '烧脑反转层层推进，四部高分悬疑片陪你度过不眠之夜',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20atmosphere%20with%20dramatic%20chiaroscuro%20lighting%2C%20deep%20shadows%2C%20warm%20selective%20highlights%2C%20film%20noir%20style%2C%20mysterious%20composition%2C%20professional%20cinematic%20look%2C%20no%20text&width=800&height=450&seq=media-thriller-02&orientation=landscape',
    duration: '4部精选',
  },
  {
    title: '治愈周末 · 温馨喜剧合集',
    desc: '轻松解压的喜剧电影大放送，高清画质治愈你的每个周末',
    img: 'https://readdy.ai/api/search-image?query=Warm%20bright%20comedy%20film%20concept%20with%20golden%20hour%20lighting%2C%20soft%20bokeh%20background%2C%20cinematic%20composition%2C%20joyful%20warm%20atmosphere%2C%20film%20grain%20texture%2C%20professional%20movie%20aesthetic%2C%20no%20text%20no%20people&width=800&height=450&seq=media-comedy-03&orientation=landscape',
    duration: '6部精选',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          编辑精选的影视专题，发现更多值得熬夜追的好片
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100/70 border border-background-200/60 rounded-xl overflow-hidden transition-all duration-200 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`夜猫电影院${item.title} - ${item.desc}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.minHeight = '0';
                    (target.parentElement as HTMLElement).classList.add('hidden');
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/80 flex items-center justify-center backdrop-blur-sm transition-transform duration-200 group-hover:scale-110">
                    <i className="ri-play-fill text-accent-600 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-background-950/70 text-background-50 text-xs font-medium whitespace-nowrap backdrop-blur-sm">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}